"use client";

import { useEffect, useRef } from "react";

interface ModalOverlayProps {
  children: React.ReactNode;
  onClick?: () => void;
}

/**
 * Full-viewport overlay used by every modal in the app. Aligned on the
 * Upload Modal V2 visual language : strong glass backdrop + 10px blur, so
 * the studio behind the modal melts into a frosted layer. The blur
 * gracefully degrades on browsers that do not support `backdrop-filter`
 * thanks to the underlying tinted background.
 */
export function ModalOverlay({ children, onClick }: ModalOverlayProps) {
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <div
      ref={overlayRef}
      className="fixed inset-safe z-50 flex items-center justify-center px-4 briefing-enter"
      style={{
        backgroundColor: "var(--color-glass-backdrop-strong)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
